import { render, staticRenderFns } from "./ReturnTracking.vue?vue&type=template&id=5225dc94&scoped=true&"
import script from "./ReturnTracking.vue?vue&type=script&lang=js&"
export * from "./ReturnTracking.vue?vue&type=script&lang=js&"
import style0 from "./ReturnTracking.vue?vue&type=style&index=0&id=5225dc94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225dc94",
  null
  
)

export default component.exports